import React, { useState, useContext, useEffect } from 'react';
import AlertBox from '../AlertBox/AlertBox';
import { AuthContext } from '../../Context/AuthContext';
const axios = require('axios');
const { API_URL } = require('../../MetaData/Metadata')

const Login = (props) => {
    const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);

    const [register_no, setRegister_no] = useState(null);
    const [password, setPassword] = useState(null);
    const [isLoginFailed, setIsLoginFailed] = useState(false);
    const [errorMessage, setErrorMessage] = useState('no message');

    const login = async (register_no, password) => {
        try {
            const apiRoute = `${API_URL}/student/login`;
            const loginRequest = await axios.post(apiRoute, { register_no: register_no, password: password });
            const response = await loginRequest.data;
            localStorage.setItem('token', response.token);
            setIsAuthenticated(true);
            props.history.push('/');
        } catch (error) {
            setIsLoginFailed(true);
            setErrorMessage("Please check your Register no and password and try again")
            console.error(error);
        }
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        const makeLoginRequest = await login(register_no, password);
    }

    return (
        <div className="container mt-5">
            <form>
                <div className="row justify-content-center">
                    <div className="col-10">
                        <div className="text-center"><h4 className="mb-4">Sign In</h4></div>
                        {/* Register no*/}
                        <input type="text" id="registerno" className="form-control mb-4" placeholder="Register No" name="register_no" onChange={e => setRegister_no(e.target.value)} />
                        {/* Password */}
                        <input type="password" id="password" className="form-control mb-4" placeholder="Date Of Birth" name="password" onChange={e => setPassword(e.target.value)} />
                        {/*Sign in button*/}
                        <button className="btn btn-info btn-block my-4" onClick={onSubmit}>Sign in</button>
                    </div>
                    <div className="alert alert-primary" role="alert">
                        <h4>Note</h4>
                        <p><b>*</b> NME Options form for First year students studying Foundation Tamil language</p>
                        <hr></hr>
                        Password should be Entered in the format DDMMYYYY<br></br>
                        <strong>Example</strong><br></br>
                        If the D.O.B is 31 December 2001<br></br>
                        then the password will be 31122001
                    </div>
                </div>
            </form>
            {(isLoginFailed) ? <AlertBox alertType='danger' heading='Login error' message={errorMessage} /> : <div></div>}
        </div>
    );
}
export default Login